import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    // flexGrow: 1,
  },
  content: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    width: '80%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  avatarInput: {
    marginBottom: 32,
    position: 'relative',
    top: 172,
    width: 186,
    alignSelf: 'center',
  },
  avatarImage: {
    width: 186,
    height: 186,
    borderRadius: '50%',
    objectFit: 'cover',
  },
  avatarLabel: {
    position: 'absolute',
    width: 48,
    height: 48,
    background: theme.palette.primary.main,
    borderRadius: '50%',
    right: 0,
    bottom: 0,
    border: 0,
    cursor: 'pointer',
    transition: 'background-color 0.2s',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarButton: {
    display: 'none',
  },
  input: {
    width: '100%',
    marginTop: 32,
    borderRadius: 16,
    backgroundColor: 'rgba(195, 155, 225, 0.2)',
    '&:hover': {
      borderColor: '#7030A0',
    },
    '& .Mui-disabled': {
      backgroundColor: theme.palette.background.default,
      borderRadius: 16,
    },
    '& input': {
      textAlign: 'flex-start',
      fontSize: 14,
      fontWeight: 'bold',
    },
    '& input::placeholder': {
      color: 'rgba(0,0,0,1)',
      fontWeight: 'bold',
      fontSize: 12,
      textAlign: 'center',
    },
    '& .MuiOutlinedInput-input': {
      borderWidth: 0,
    },
    '& .Mui-focused': {
      border: 'none',
    },
  },
  floatingButton: {
    maxWidth: 240,
    height: 48,
    position: 'relative',
    top: 0,
    left: -56,
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    border: 'none',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 8,
  },
  title: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  backButton: {
    borderRadius: 32,
    border: 'none',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: 32,
  },
  cancelButton: {
    width: '45%',
    height: 56,
    borderRadius: 16,
    fontSize: 18,
  },
  saveButton: {
    width: '45%',
    marginLeft: 24,
    height: 56,
    borderRadius: 16,
    fontSize: 18,
  },
}));
